import { Dayjs } from 'dayjs';
import create from 'zustand';

type SetDates = {
  initial_date: Dayjs | null;
  final_date: Dayjs | null;
};

type IrmCalendarState = {
  initial_date: Dayjs | null;
  final_date: Dayjs | null;
  setDates: (dates: SetDates) => void;
};

export const useIrmCalendarStore = create<IrmCalendarState>((set) => {
  const setDates = (props: SetDates) =>
    set((state) => {
      return { ...state, ...props };
    });

  return {
    initial_date: null,
    final_date: null,
    setDates,
  };
});
